// eslint-disable-next-line @typescript-eslint/no-unused-vars
import UIkit from 'uikit/dist/js/uikit-core';
import initSlideshows from './theme/slideshow';
import initHeaderSearch from './theme/headerSearch';
import initCaseStudy from './theme/caseStudy';
import initPageNavigation from './theme/pageNavigation';
import initProfileArchive from './theme/profileArchive';
import initGSAP from './theme/gsap';

// Avoid interfering with GP Popups admin-bar debug panel toggle.
// The admin bar trigger is present when `gp-popups` is enabled for the user.
const hasGpPopupsAdminBarTrigger = document.querySelector(
  '#wp-admin-bar-gp-popups'
);
if (!hasGpPopupsAdminBarTrigger) {
  initGSAP();
}
initHeaderSearch();
initSlideshows();
initCaseStudy();
initPageNavigation();
if (document.querySelector('[data-profile-archive]')) {
  initProfileArchive();
}